const { STYLES_COLOR } = require('modules/styles/constants/index.cjs')

const ORDER_MODEL_CLASS_NAME = 'Order'

const ORDER_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  STATUS: 'status',
  KEY: 'key',
  SHIPPING: 'shipping',
  SUB_TOTAL: 'subTotal',
  TAX: 'tax',
  TOTAL: 'total',
  REFUND: 'refund',
  CURRENCY: 'currency',
  ERROR: 'error',
  SHIPPING_SERVICE: 'shippingService',
  SHIPPING_LABEL: 'shippingLabel',
  TRACKING: 'tracking',
  DELIVERED_AT: 'deliveredAt',
  PAYMENT_TYPE: 'paymentType',
  NOTES: 'notes',
  ADDRESS: 'address',
  ORDER_PRODUCTS: 'orderProducts',
  PROMO_CODES: 'promoCodes',
  CATEGORIES: 'categories',
  USER: 'user',
  // Foreign keys
  ADDRESS_ID: 'addressId',
  USER_ID: 'userId'
}

const ORDER_MODEL_KEY_POINTER = ORDER_MODEL_KEY.KEY
const ORDER_MODEL_STATUS = {
  SUBMITTED: 1,
  PENDING: 2,
  PREPARATION: 3,
  SHIPPED: 4,
  DELIVERED: 5,
  FAILED: 6,
  CANCELLED: 7,
  RETURNED: 8,
  REFUNDED: 9,
  PAY_PAL_PENDING: 10,
  PARTIALLY_REFUNDED: 11
}

const ORDER_MODEL_STATUS_LABEL = {
  [ORDER_MODEL_STATUS.SUBMITTED]: 'submitted',
  [ORDER_MODEL_STATUS.PENDING]: 'pending',
  [ORDER_MODEL_STATUS.PREPARATION]: 'preparation',
  [ORDER_MODEL_STATUS.SHIPPED]: 'shipped',
  [ORDER_MODEL_STATUS.DELIVERED]: 'delivered',
  [ORDER_MODEL_STATUS.FAILED]: 'failed',
  [ORDER_MODEL_STATUS.CANCELLED]: 'cancelled',
  [ORDER_MODEL_STATUS.RETURNED]: 'returned',
  [ORDER_MODEL_STATUS.REFUNDED]: 'refunded',
  [ORDER_MODEL_STATUS.PAY_PAL_PENDING]: 'paypal payment pending',
  [ORDER_MODEL_STATUS.PARTIALLY_REFUNDED]: 'partially refunded'
}

const ORDER_MODEL_STATUSES_LABEL = Object.values(ORDER_MODEL_STATUS_LABEL)
const ORDER_MODEL_STATUSES_CANCELLABLE = [
  ORDER_MODEL_STATUS.SUBMITTED,
  ORDER_MODEL_STATUS.PENDING
]
const ORDER_MODEL_STATUS_COLOR = {
  [ORDER_MODEL_STATUS.SUBMITTED]: STYLES_COLOR.BLUE,
  [ORDER_MODEL_STATUS.PENDING]: STYLES_COLOR.BLACK_LIGHT,
  [ORDER_MODEL_STATUS.PREPARATION]: STYLES_COLOR.BLUE,
  [ORDER_MODEL_STATUS.SHIPPED]: STYLES_COLOR.BLUE,
  [ORDER_MODEL_STATUS.DELIVERED]: STYLES_COLOR.BLUE,
  [ORDER_MODEL_STATUS.FAILED]: STYLES_COLOR.RED,
  [ORDER_MODEL_STATUS.CANCELLED]: STYLES_COLOR.RED,
  [ORDER_MODEL_STATUS.RETURNED]: STYLES_COLOR.RED,
  [ORDER_MODEL_STATUS.REFUNDED]: STYLES_COLOR.RED,
  [ORDER_MODEL_STATUS.PAY_PAL_PENDING]: STYLES_COLOR.BLACK_LIGHT,
  [ORDER_MODEL_STATUS.PARTIALLY_REFUNDED]: STYLES_COLOR.BLUE
}

const ORDER_MODEL_PLACEHOLDER = {
  [ORDER_MODEL_KEY.STATUS]: ORDER_MODEL_STATUS.SUBMITTED,
  [ORDER_MODEL_KEY.KEY]: '9Qa2RPnBdOJ',
  [ORDER_MODEL_KEY.SHIPPING]: 8,
  [ORDER_MODEL_KEY.SUB_TOTAL]: 24,
  [ORDER_MODEL_KEY.TAX]: 0,
  [ORDER_MODEL_KEY.TOTAL]: 32,
  [ORDER_MODEL_KEY.REFUND]: null,
  [ORDER_MODEL_KEY.SHIPPING_SERVICE]: 'Small Parcel Air',
  [ORDER_MODEL_KEY.TRACKING]: null,
  [ORDER_MODEL_KEY.DELIVERED_AT]: null,
  [ORDER_MODEL_KEY.PAYMENT_TYPE]: null,
  [ORDER_MODEL_KEY.NOTES]: null,
  [ORDER_MODEL_KEY.ADDRESS_ID]: '1',
  [ORDER_MODEL_KEY.USER_ID]: '1'
}

const ORDER_MODEL_VALIDATOR = {
  [ORDER_MODEL_KEY.KEY]: 11
}

/**
 * A mapping of key to a list of labels.
 * @type {Object}
 */
const ORDER_MODEL_KEY_SELECT_LABEL = {
  [ORDER_MODEL_KEY.STATUS]: ORDER_MODEL_STATUS_LABEL
}

const ORDER_MODEL_TRACKING_URL = 'https://www.canadapost.ca/track-reperage/en#/details/'

/**
 * A list of keys that are associated to the instance.
 * @type {Array}
 */
const ORDER_MODEL_ASSOCIATION = {
  [ORDER_MODEL_KEY.ADDRESS]: 'Address',
  [ORDER_MODEL_KEY.CATEGORIES]: 'Category',
  [ORDER_MODEL_KEY.ORDER_PRODUCTS]: 'OrderProduct',
  [ORDER_MODEL_KEY.PROMO_CODES]: 'PromoCode',
  [ORDER_MODEL_KEY.USER]: 'User'
}

module.exports = {
  ORDER_MODEL_CLASS_NAME,
  ORDER_MODEL_KEY,
  ORDER_MODEL_KEY_POINTER,
  ORDER_MODEL_KEY_SELECT_LABEL,
  ORDER_MODEL_PLACEHOLDER,
  ORDER_MODEL_VALIDATOR,
  ORDER_MODEL_STATUS,
  ORDER_MODEL_STATUS_LABEL,
  ORDER_MODEL_STATUSES_LABEL,
  ORDER_MODEL_STATUSES_CANCELLABLE,
  ORDER_MODEL_STATUS_COLOR,
  ORDER_MODEL_TRACKING_URL,
  ORDER_MODEL_ASSOCIATION
}
